/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ enrolled: NonNullable<unknown> }} Partner_Admin_Kpi_Enrolled_CountInputs */



/**
* | output |
* | --- |
* | "{enrolled} enrolled" |
*
* @param {Partner_Admin_Kpi_Enrolled_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_kpi_enrolled_count = /** @type {((inputs: Partner_Admin_Kpi_Enrolled_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Kpi_Enrolled_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.enrolled} eingerichtet`)
	return /** @type {LocalizedString} */ (`${i?.enrolled} enrolled`)
});